import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  children: React.ReactNode;
  className?: string;
}

export const Shadow: React.SFC<IProps> = props => (
  <Container className={props.className}>{props.children}</Container>
);

const Container = styled.div`
  box-shadow: 0 2px 2px #cacfd6;
`;

export default Shadow;



// WEBPACK FOOTER //
// ./src/components/Shadow/Shadow.tsx